// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from "fg-frontend/src/lib/classNames";

const fragments = {
  MAP: '[data-fragment="ContactsMap.map"]',
  MAP_FRAGMENTS: '[data-fragment="ContactsMap.map.fragment"]',
  MAP_CARD: '[data-fragment="ContactsMap.card"]',
  MAP_SHOW_ALL: '[data-fragment="ContactsMap.show.all"]',
  MAP_CARD_CLOSE: '[data-fragment="ContactsMap.card.close"]',
  MAP_CARD_CONTENT: '[data-fragment="ContactsMap.card.content"]',
};

export default class ContactsMap extends WebComponent {

  constructor(props) {
    super(props);
    this.fragments = document.querySelectorAll(fragments.MAP_FRAGMENTS);
    this.card = document.querySelector(fragments.MAP_CARD);
    this.mapShowAllContactsBtn = document.querySelector(fragments.MAP_SHOW_ALL);
    this.cardClose = document.querySelector(fragments.MAP_CARD_CLOSE);
    this.cardContent = document.querySelector(fragments.MAP_CARD_CONTENT);
    this.state = {
      regionSelected: false,
      showAllBtnHidden: false,
    };
    // bind events
    this.renderCard = this.renderCard.bind(this);
    this.closeCard = this.closeCard.bind(this);
  }

  didMount() {
    const self = this;
    this.mapSourceDataPath = this.element.dataset.source;
    // anonymous functions
    self._renderCard = function(e) {self.renderCard(e, this)}
    // btn click
    this.mapShowAllContactsBtn.addEventListener('click', self._renderCard)
    // fragments click
    this.fragments.forEach((fragment)=>{
      fragment.addEventListener('click', self._renderCard);
    })
    // close card
    this.cardClose.addEventListener('click', this.closeCard);
  }

  renderCard(e) {
    this.cardContent.innerHTML = '';
    this.setState({ regionSelected: true });
    this.setState({ showAllBtnHidden: false });
    // scroll into view
    this.element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    /**
     * Specific region setup
     */
    if(e.target.classList.contains('contacts__map-region')) {
      //remove colors
      this.fragments.forEach((fragment)=>{
        fragment.classList.remove('contacts__map-region--active');
      });
      // adding active
      e.target.classList.add('contacts__map-region--active');
      // fill card with necessary
      const req = new Request(this.mapSourceDataPath);
      fetch(req)
        .then(response => response.json())
        .then(data => {
          for (const region of data.mapData.region) {
            if(e.target.dataset.regionCode === region.code) {
              // set correct region name
              let cardContent = '';
              cardContent = '';
              cardContent = `<h3 class="contacts__map-card-title">${region.name}</h3>`;
              region.contacts.forEach((contact) => {
                cardContent += '<div class="contacts__map-card-person">';
                if (contact.img) cardContent += `<img class="contacts__map-card-img" width="75" height="75" src="${contact.img}" alt="${contact.name}">`;
                cardContent += `
                    <h4 class="contacts__map-card-person-name">${contact.name}</h4>
                    <p class="contacts__map-card-person-phone"><a class="contacts__map-card-link contacts__map-card-link--phone" href="tel:${contact.phone}">${contact.phone}</a></p>
                    <p class="contacts__map-card-person-mail"><a class="contacts__map-card-link contacts__map-card-link--mail" href="mailto:${contact.mail}">${contact.mail}</a></p>
                  </div>
                `;
              });
              this.cardContent.innerHTML = cardContent;
              // placing card next to the cursor
              const offset = 10;
              if (window.innerWidth > 768) {
                if (e.pageX - this.element.offsetLeft + offset < 401){
                  // console.log(e.pageX - this.element.offsetLeft + offset + 'px');
                  this.card.style.left = e.pageX - this.element.offsetLeft + offset + 'px';
                  this.card.style.top = e.pageY - this.element.offsetTop + offset + 'px';
                }else {
                  this.card.style.left = e.pageX - this.element.offsetLeft - 390 - offset + 'px'; // 390 card width
                  this.card.style.top = e.pageY - this.element.offsetTop + offset + 'px';
                }
              }
            }
          }
        })
        .catch(console.error);

    }else { // show all
      this.setState({ showAllBtnHidden: true });
      //remove colors
      this.fragments.forEach((fragment)=>{
        fragment.classList.remove('contacts__map-region--active');
      });
      const req = new Request(this.mapSourceDataPath);
      fetch(req)
        .then(response => response.json())
        .then(data => {
          for (const region of data.mapData.region) {
            region.contacts.forEach((contact) => {
              let cardContent = '';
              cardContent += `
                <div class="contacts__map-card-person">
                    <h3 class="contacts__map-card-title">${region.name}</h3>`;
              if (contact.img) cardContent += `<img class="contacts__map-card-img" width="75" height="75" src="${contact.img}" alt="${contact.name}">`;
              cardContent += `
                    <h4 class="contacts__map-card-person-name">${contact.name}</h4>
                    <p class="contacts__map-card-person-phone"><a class="contacts__map-card-link contacts__map-card-link--phone" href="tel:${contact.phone}">${contact.phone}</a></p>
                    <p class="contacts__map-card-person-mail"><a class="contacts__map-card-link contacts__map-card-link--mail" href="mailto:${contact.mail}">${contact.mail}</a></p>
                </div>`;
              this.cardContent.innerHTML += cardContent;
            });
          }
        })
        .catch(console.error);
    }
  }

  closeCard() {
    const self = this;
    this.setState({ regionSelected: false });
    // clear card
    self.cardContent.innerHTML = '';
    // remove classes
    self.fragments.forEach((fragment)=>{
      fragment.classList.remove('contacts__map-region--active');
    });
  }

  willUnMount() {
    this.fragments.forEach((fragment)=>{
      fragment.removeEventListener('click');
    })
    // close card
    this.cardClose.removeEventListener('click');
    // btn click
    this.mapShowAllContactsBtn.removeEventListener('click')
  }

  update() {
    const {
      regionSelected,
      showAllBtnHidden,
    } = this.state;
    classNames(this.card, { active: regionSelected });
    classNames(this.cardClose, { hidden: showAllBtnHidden });
    classNames(this.card, { 'contacts__map-card--show-all': showAllBtnHidden });
    classNames(this.mapShowAllContactsBtn, { 'hidden': showAllBtnHidden });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ContactsMap.js